import { ENC } from "@/constants/testIds";
import { NA, formatDate } from "@/lib/patientChart";

/**
 * Compact patient identity, always visible in the Documentation column.
 * Patient safety requirement: name/MRN/DOB must never disappear, even when
 * the Patient Chart column is collapsed — this is the only place it renders.
 */
export default function PatientIdentityBar({ fields }) {
  return (
    <div data-testid={ENC.screenIdentityBar} className="emr-encdetail__identity-bar">
      <div className="min-w-0">
        <div className="emr-encdetail__identity-row">
          <span data-testid={ENC.screenIdentityName} className="emr-encdetail__identity-name">
            {fields?.name || NA}
          </span>
          <span
            className={
              fields?.active === false
                ? "emr-encdetail__chip emr-encdetail__chip--inactive"
                : "emr-encdetail__chip emr-encdetail__chip--active"
            }
          >
            {fields?.active === false ? "Inactive" : "Active"}
          </span>
        </div>
        <div className="emr-encdetail__identity-meta">
          <span data-testid={ENC.screenIdentityMrn}>MRN {fields?.mrn || NA}</span>
          <span className="emr-encdetail__identity-sep">|</span>
          <span data-testid={ENC.screenIdentityDob}>
            DOB {fields?.birthDate ? formatDate(fields.birthDate) : NA}
          </span>
        </div>
      </div>
    </div>
  );
}
